module.exports = __webpack_public_path__ + "static/img0-1e0ff55450dcd17e9564e47d689f1179.png";